import { stories } from "../data/stories";
import PremiumStoryCard from "../components/StoriesSection";

export default function Stories() {
  return (
    <section className="py-14 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h1 className="text-2xl md:text-4xl font-bold mb-12">
          All Stories
        </h1>

        <div className="grid gap-10 lg:grid-cols-2">
          {stories.map((story) => (
            <PremiumStoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}